(function () {
    'use strict';
    var m = angular.module('dao');
    m.factory('apAvananExceptionsDao', ["http", "sqlQueries", "defaultListConverter", function (http, sqlQueries, defaultListConverter) {
        return {
            list: function (type, columns, userMap) {
                return http.get(sqlQueries('ap_avanan_exceptions_' + type)).params({ type: type }).converter(defaultListConverter, {
                    columns: columns,
                    converters: {
                        avananUserInfoConverter: function (text, columnId, columnsMap, args, allConverters) {
                            var userInfo = userMap[text] || {};
                            return allConverters.userWithEmail(userInfo.name, columnId, userInfo, {
                                emailColumn: 'email',
                                userIdColumn: 'noIdNeeded'
                            });
                        },
                        actionsConverter: function (text, columnId, columnsMap, args) {
                            var result = '#' + JSON.stringify({
                                display: 'text',
                                'class': 'edit-action-link fa fa-pencil',
                                tooltip: 'Edit',
                                clickEvent: {
                                    name: 'edit-exception',
                                    entityId: columnsMap.entity_id,
                                    defaultData: columnsMap,
                                    type: 'edit'
                                }
                            });
                            return result;
                        },
                        avananEmailReplacementConverter: function (text, columnId, columnsMap, args, allConverters) {
                            if (!text)
                                return text;
                            return text.endsWith('@avanan.com') ? 'Avanan Analysts' : text;
                        }
                    }
                });
            },
            add: function (data) {
                return http.post('/api/v1/ap_avanan/exception_all').body(data).run();
            },
            add2: function (data) {
                data.mail_explorer_version = 2;
                // return http.post('/api/v1/ap_avanan/exception_all').body(data).run();
                return http.post('/api/v1/mail_explorer2/exception/whitelist').body(data).run();
            },
            edit: function (data) {
                return http.post('/api/v1/ap_avanan/edit').body(data).run();
            },
            remove: function (data) {
                return http.post('/api/v1/ap_avanan/exception_all/delete').body(data).run();
            },
            removeEmailsPerOwner: function (data) {
                return http.post('/api/v1/ap_avanan/exceptions_per_owner/delete').body(data).run();
            },
            whitelistOptions: function (entityType, entityId) {
                return http.get('/api/v1/ap_avanan/exception/options/' + entityType + '/' + entityId);
            },
            whitelistMatching: function (params) {
                return http.post('/api/v1/ap_avanan/exception_search').body(params);
            },
            exceptionComboOptions: function (params) {
                return http.post('/api/v1/ap_avanan/combo_options').body(params);
            },
            blacklistOptions: function (entityType, entityId) {
                return http.get('/api/v1/ap_avanan/blacklist/options/' + entityType + '/' + entityId);
            },
            blacklistMatching: function (params) {
                return http.post('/api/v1/ap_avanan/blacklist').body(params);
            },
            blacklistCreate: function (params) {
                return http.put('/api/v1/ap_avanan/blacklist').body(params);
            },
            blacklistCreate2: function (params) {
                params.mail_explorer_version = 2;
                // return http.put('/api/v1/ap_avanan/blacklist').body(params);
                return http.post('/api/v1/mail_explorer2/exception/blacklist').body(params);
            },
            blacklist: function () {
                return http.get('/api/v1/ap_avanan/blacklist');
            },
            blacklistItem: function (itemId) {
                return http.get('/api/v1/ap_avanan/blacklist/' + itemId);
            },
            removeBlacklistItems: function (data) {
                return http.post('/api/v1/ap_avanan/blacklist/delete').body(data).run();
            },
            blacklistDomains: function () {
                return http.get('/api/v1/ap_avanan/blacklist_domain');
            },
            removeBlacklistDomains: function (data) {
                return http.post('/api/v1/ap_avanan/blacklist_domain/delete').body(data).run();
            }
        };
    }]);
}());